export default __webpack_public_path__ + "static/pen-5f4625c8dba0461c951df1f964ef456b.png";